import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { getStudentBookedCourseListData, getStudentQueriesDetailData, getStudentQueriesListData } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';
import ResponsivePagination from '../../../../Common/Pagination';

const host = process.env.REACT_APP_API_SERVER
const StudentNotesQueries = () => {
    const dispatch = useDispatch();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    useEffect(() => {

        dispatch(getStudentBookedCourseListData());
        dispatch(getStudentQueriesListData());

    }, []);

    const handleViewQuery = (id) => {
        dispatch(getStudentQueriesDetailData(id));
    }

    const {

        loadingStudentQueriesListApi,
        StudentQueriesListApiData,
        StudentQueriesListApiError,

        loadingStudentQueriesDetailApi,
        StudentQueriesDetailApiData,
        StudentQueriesDetailApiError,

        loadingStudentBookedCourseListApi,
        StudentBookedCourseListApiData,
        StudentBookedCourseListApiError
    } = useSelector(state => state?.StudentReducer);






    const triggerModalClose = () => {
        const closeButton = document.getElementById('close-modal');
        if (closeButton) {
            closeButton.click();
        }

    };

    let [initialValues, setInitialValues] = useState({

        course_id: "",
        title: "",
        doubt_description: "",


    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            course_id: Yup.string().required("Course is required."),

            title: Yup.string().required("Title is required"),
            doubt_description: Yup.string().required("Description is required"),

        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {


                setSubmitting(true);
                let config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('student-token'),

                    },
                };

                await axios.post(`${host}/api/student/study-material/my-query`, values, config)
                    .then(function (response) {

                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success('Your query submitted successfully');
                            resetForm();
                            triggerModalClose();
                            dispatch(getStudentQueriesListData());
                        } else {

                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {


                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {


                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })


    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!StudentQueriesListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(StudentQueriesListApiData.slice(start, end));
        setPageCount(Math.ceil(StudentQueriesListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, StudentQueriesListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;My Queries
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    {/* <ul class="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                              <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                  data-bs-target="#home" type="button" role="tab" aria-controls="home"
                                  aria-selected="true">One To One</button>
                          </li>
                          <li class="nav-item" role="presentation">
                              <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                  data-bs-target="#profile" type="button" role="tab" aria-controls="profile"
                                  aria-selected="false">Group Courses</button>
                          </li>
                      </ul> */}
                                    <div className="browse-tutor">

                                        <div className="row justify-content-end">
                                            {/* <div className="col-lg-4  offset-lg-4">
                                                <input
                                                    type="text"
                                                    placeholder="Search Queries"
                                                    className="input-card-form"
                                                    required=""
                                                />
                                            </div>
                                            <div className="col-lg-2 col-md-6 col-sm-6">
                                                <a href="">
                                                    <button className="btn btn-primary mb-1 w-100">search</button>
                                                </a>
                                            </div> */}
                                            <div className="col-lg-2 col-md-6 col-sm-6">
                                                <button
                                                    className="btn btn-primary mb-1 w-100"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#addqueries"
                                                >
                                                    Add Query <i className="fa fa-plus" aria-hidden="true" />
                                                </button>
                                            </div>
                                            <p class=" mt-3" style={{ fontSize: '16px', color: "#007bff" }}>Got a question about a course? Ask directly! Any queries related to course content, schedules, or learning materials will be sent to the respective tutor for clarification.</p>

                                        </div>
                                    </div>
                                    {/*  */}
                                    <div className="tab-content-student my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingStudentQueriesListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row">
                                                    {StudentQueriesListApiData?.length > 0 ?
                                                        currentData?.map((data) => (
                                                            <div className="col-lg-6 mt-3 col-md-6" key={data?.id}>
                                                                <div
                                                                    className="card input-card-form notescard bg-white "
                                                                    onClick={() => { handleViewQuery(data?.id) }}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#viewQueryModal"
                                                                >
                                                                    <div className="card-body">
                                                                        <div className="row">
                                                                            <div className="col-lg-12 d-flex justify-content-end">
                                                                                <p
                                                                                    className="mb-0"
                                                                                    style={{ fontSize: 16, color: "#007bff" }}
                                                                                >
                                                                                    {data?.course?.name}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-6 ">
                                                                                <div
                                                                                    className="card input-card-form mb-0"
                                                                                    style={{ backgroundColor: "aliceblue" }}
                                                                                >
                                                                                    <div className="card-body text-center mb-0">
                                                                                        <h5>{new Date(data?.createdAt).getUTCDate()}</h5>
                                                                                        <h6>{monthNames[new Date(data?.createdAt).getUTCMonth()]}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-8 d-flex col-md-8 col-sm-6 flex-column justify-content-center align-items-start">
                                                                                <h5 className="mb-0 text-dark mt-2">{data?.tutor?.name}</h5>
                                                                                <p className="mb-0">{data?.title}</p>
                                                                                <p className="mb-0 line-clamp">{data?.doubt_description}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}

                                                </div>}
                                            {pageCount > 1 && (
                                                <ResponsivePagination
                                                    pageCount={pageCount}
                                                    currentPage={currentPage}
                                                    handlePageClick={handlePageClick}
                                                />
                                            )}
                                            {/* CSS for styling the pagination */}
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n                                        .pagination .page-item .page-link {\n                                            border: none;\n                                            margin: 0 5px;\n                                            padding: 10px 15px;\n                                            color: #555;\n                                            font-weight: 500;\n                                            font-size: 1rem;\n                                            border-radius: 8px;\n                                            transition: all 0.3s ease;\n                                            background-color: #f1f3f5;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n                                        }\n\n                                        /* Hover effect */\n                                        .pagination .page-item .page-link:hover {\n                                            background-color: #e0e4e7;\n                                            color: #333;\n                                            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n                                            transform: translateY(-2px);\n                                        }\n\n                                        /* Active page styling */\n                                        .pagination .page-item.active .page-link {\n                                            background-color: #007bff;\n                                            color: #fff;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n                                        }\n\n                                        /* Disabled button styling */\n                                        .pagination .page-item.disabled .page-link {\n                                            color: #aaa;\n                                            background-color: #f1f3f5;\n                                            pointer-events: none;\n                                        }\n\n                                        /* Chevron icon styling */\n                                        .pagination .page-item .page-link i {\n                                            font-size: 1rem;\n                                        }\n                                    "
                                                }}
                                            />
                                        </div>
                                        {/* <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div class="row">
                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4 ">
                                                      <img src="./assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark mt-2">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4 ">
                                                      <img src="./assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark mt-2">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>

                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4 ">
                                                      <img src="./assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark mt-2">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4 ">
                                                      <img src="./assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark mt-2">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a class="btn btn-primary py-1 mt-1 "
                                                              style="padding-inline: 35px;" href="./chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div> */}
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

            <>
                {/* add querry popup */}
                <div
                    className="modal fade"
                    id="addqueries"
                    tabIndex={-1}
                    aria-labelledby="addqueriesLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addqueriesLabel">
                                    Add Query
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    id='close-modal'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ maxHeight: 500 }}>
                                {/* Form Content */}
                                <form method='post' onSubmit={formik.handleSubmit}>
                                    {/* Select Course */}
                                    <div className="mb-3">
                                        <label htmlFor="courseSelect" className="form-label text-muted">
                                            Select Course
                                        </label>
                                        <select
                                            className="form-select"
                                            id="courseSelect"
                                            aria-label="Select Course"
                                            name='course_id'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.course_id}
                                        >
                                            <option selected="">Select Course</option>
                                            {StudentBookedCourseListApiData?.map((data) => (
                                                <option value={data?.id}>{data?.name}</option>
                                            ))}

                                        </select>
                                        <div className="help-block with-errors">
                                            {formik.touched.course_id && formik.errors.course_id ? (
                                                <div className='text-danger'>{formik.errors.course_id}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    {/* Title */}
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="titleInput"
                                            placeholder="Title"
                                            name='title'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.title}
                                        />
                                        <div className="help-block with-errors">
                                            {formik.touched.title && formik.errors.title ? (
                                                <div className='text-danger'>{formik.errors.title}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="mb-3">
                                        <textarea
                                            className="form-control"
                                            id="descriptionInput"
                                            rows={3}
                                            placeholder="Doubt Description"
                                            defaultValue={""}
                                            name='doubt_description'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.doubt_description}
                                        />
                                        <div className="help-block with-errors">
                                            {formik.touched.doubt_description && formik.errors.doubt_description ? (
                                                <div className='text-danger'>{formik.errors.doubt_description}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <button disabled={formik.isSubmitting} className="btn btn-primary " type='submit'>Add Query</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* view querry */}
                <div
                    className="modal fade"
                    id="viewQueryModal"
                    tabIndex={-1}
                    aria-labelledby="viewQueryModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="viewQueryModalLabel">
                                    View Query
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ maxHeight: 540 }}>
                                {/* Display Query Information */}
                                {loadingStudentQueriesDetailApi ?
                                    <Beatloader />
                                    : <form>
                                        {/* Tutor */}
                                        <div className="mb-3">
                                            <label htmlFor="tutor" className="form-label text-muted">
                                                Tutor
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="tutor"
                                                defaultValue={StudentQueriesDetailApiData?.tutor?.name}
                                                readOnly
                                            />
                                        </div>

                                        {/* Title */}
                                        <div className="mb-3">
                                            <label htmlFor="title" className="form-label text-muted">
                                                Title
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="title"
                                                defaultValue={StudentQueriesDetailApiData?.title}
                                                readOnly
                                            />
                                        </div>
                                        {/* Doubt Description */}
                                        <div className="mb-3">
                                            <label htmlFor="description" className="form-label text-muted">
                                                Doubt Description
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="description"
                                                rows={2}
                                                defaultValue={StudentQueriesDetailApiData?.doubt_description}
                                                readOnly
                                            />
                                        </div>
                                        {/* Answer */}
                                        <div className="mb-3">
                                            <label htmlFor="answer" className="form-label text-muted">
                                                Answer
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="answer"
                                                rows={2}
                                                defaultValue={StudentQueriesDetailApiData?.answer}
                                                readOnly
                                            />
                                        </div>
                                    </form>}
                            </div>
                        </div>
                    </div>
                </div>
            </>


        </div>
    )
}

export default StudentNotesQueries